<template>
  <div class="register-bonuses__fog-bg-container">
    <Transition name="scale-fade">
      <img
        :key="imgSrc"
        class="register-bonuses__fog-bg"
        :src="`/img/welcome-pack/fog/${imgSrc}.webp`"
        alt="beton welcome pack"
      />
    </Transition>
  </div>
</template>
<script>
const BG_FOG = ['violet', 'green', 'yellow']
export default {
  name: 'RegistrationBonusSliderFog',
  props: {
    selectedBonus: { type: Object, required: true },
  },
  computed: {
    imgSrc() {
      if (this.selectedBonus.isPromocode) return 'grey'
      if (this.selectedBonus.isVip) return 'brownish'
      if (this.selectedBonus.isPromocodeBonus) return 'yellow'
      return BG_FOG[this.selectedBonus.index] || BG_FOG[0]
    },
  },
}
</script>
<style lang="scss" scoped>
  .register-bonuses {
    &__fog-bg-container {
      --fog__s: 400px;
      
      position: absolute;
      top: calc(50% + 38px);
      left: 50%;
      width: var(--fog__s);
      max-width: 100%;
      height: var(--fog__s);
      transform: translate(-50%, -50%);
      
      @include media (tablet) {
        --fog__s: 460px;
      }
    }
    
    &__fog-bg {
      position: absolute;
      opacity: .4;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
    }
  }
  
  .scale-fade-enter-active,
  .scale-fade-leave-active {
    transition: all 0.6s ease-in;
  }

  .scale-fade-enter,
  .scale-fade-leave-to {
    opacity: 0;
  }
  
  .scale-fade-enter {
    transform: scaleX(1.4) rotateY(30deg);
  }
  
  .scale-fade-leave-to {
    transform: scaleY(1.8) rotateY(30deg);
  }
</style>
